export default __webpack_public_path__ + "static/media/6_condition.349f91f7.svg";